import { getMerchantTeams } from "@/services/role-access.service";
import { useQuery } from "@tanstack/react-query";

export const useMerchantTeams = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "merchant-teams",
    params.page,
    params.size,
    params.search,
    params.invitorId,
    params.roleName,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getMerchantTeams(params),
    enabled,
    ...options,
  });
};
